import { local } from '@/utils/storage.js'
import {
  setTagNavListInLocalstorage,
  getTagNavListFromLocalstorage,
  getNextRoute,
  routeHasExist,
  routeEqual,
  localSave,
  localRead,
  getHomeRoute,
  getBreadCrumbList,
  getRouteTitleHandled
} from '@/utils/tags.js'
import router from '@/router'
import config from '@/config'

const { homeName } = config

const BAR_COLOR_KEY = 'BAR_COLOR_KEY'
const BAR_IMAGE_KEY = 'BAR_IMAGE_KEY'
const DRAWER_KEY = 'DRAWER_KEY'
const MINIMENU_KEY = 'MINIMENU_KEY'
const STYLE_COLOR_KEY = 'STYLE_COLOR_KEY'
const THEME_KEY = 'THEME_KEY'

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => !routeEqual(item, route))
  router.push(nextRoute)
}

export const state = {
  barColor: local.getDef(BAR_COLOR_KEY, 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'),
  barImage: local.getDef(BAR_IMAGE_KEY, ''),
  drawer: local.getDef(DRAWER_KEY, true),
  miniMenu: local.getDef(MINIMENU_KEY, false),
  styColor: local.getDef(STYLE_COLOR_KEY, '#FF9800'),
  theme: local.getDef(THEME_KEY, 'light'),
  homeLoad: false,
  breadCrumbList: [],
  tagNavList: [],
  homeRoute: {},
  local: localRead('local')
}
export const mutations = {
  SET_BAR_IMAGE(state, image) {
    state.barImage = image
    local.set(BAR_IMAGE_KEY, image)
  },
  SET_DRAWER(state, boo) {
    state.drawer = boo
    local.set(DRAWER_KEY, boo)
  },
  SET_SCRIM(state, color) {
    state.barColor = color
    local.set(BAR_COLOR_KEY, color)
  },
  SET_MINIMENU(state, boo) {
    state.miniMenu = boo
    local.set(MINIMENU_KEY, boo)
  },
  SET_STYLECOLOR(state, color) {
    state.styColor = color
    local.set(STYLE_COLOR_KEY, color)
  },
  SET_THENM (state, theme) {
    state.theme = theme
    local.set(THEME_KEY, theme)
  },
  SET_HOME_LOAD(state, item) {
    state.homeLoad = item
  },
  setBreadCrumb (state, route) {
    state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
  },
  setHomeRoute (state, routes) {
    state.homeRoute = getHomeRoute(routes, homeName)
  },
  setTagNavList (state, list) {
    let tagList = []
    if (list) {
      tagList = [...list]
    } else tagList = getTagNavListFromLocalstorage() || []
    if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
    const homeTagIndex = tagList.findIndex(item => item.name === homeName)
    if (homeTagIndex > 0) {
      const homeTag = tagList.splice(homeTagIndex, 1)[0]
      tagList.unshift(homeTag)
    }
    state.tagNavList = tagList
    setTagNavListInLocalstorage([...tagList])
  },
  closeTag (state, route) {
    const tag = state.tagNavList.filter(item => routeEqual(item, route))
    route = tag[0] ? tag[0] : null
    if (!route) return
    closePage(state, route)
  },
  addTag (state, { route, type = 'unshift' }) {
    // eslint-disable-next-line no-shadow
    const router = getRouteTitleHandled(route)
    if (!routeHasExist(state.tagNavList, router)) {
      if (type === 'push') state.tagNavList.push(router)
      else if (router.name === homeName) state.tagNavList.unshift(router)
        else state.tagNavList.splice(1, 0, router)
      setTagNavListInLocalstorage([...state.tagNavList])
    }
  },
  setLocal (state, lang) {
    localSave('local', lang)
    state.local = lang
  },
}
export const getters = {
  barColor: state => state.barColor,
  barImage: state => state.barImage,
  drawer: state => state.drawer,
  miniMenu: state => state.miniMenu,
  styColor: state => state.styColor,
  theme: state => state.theme,
  homeLoad: state => state.homeLoad
}
export const actions = {
  setHomeLoad({ commit }, item) {
    commit('SET_HOME_LOAD', item)
  }
}
